import type { SVGProps } from 'react';

import { cn } from '@/lib/utils';

interface CancelledIconProps extends SVGProps<SVGSVGElement> {
  className?: string;
}

export function CancelledIcon({ className, ...props }: CancelledIconProps) {
  return (
    <svg
      viewBox="0 0 15 15"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={cn('size-5', className)}
      {...props}
    >
      <path d="M7.5 0C11.6421 0 15 3.35786 15 7.5C15 11.6421 11.6421 15 7.5 15C3.35786 15 0 11.6421 0 7.5C0 3.35786 3.35786 0 7.5 0ZM10.6104 4.38965C10.4009 4.18015 10.061 4.18015 9.85156 4.38965L7.5 6.74121L5.14941 4.38965C4.93996 4.18015 4.60008 4.18015 4.39062 4.38965C4.18156 4.59911 4.18131 4.93902 4.39062 5.14844L6.74121 7.49902L4.38965 9.85254C4.18042 10.0619 4.18067 10.4009 4.38965 10.6104C4.59913 10.8194 4.93913 10.8197 5.14844 10.6104L7.5 8.25879L9.85254 10.6113C10.062 10.8204 10.402 10.8204 10.6113 10.6113C10.8206 10.402 10.8203 10.0621 10.6113 9.85254L8.25879 7.49902L10.6104 5.14844C10.8196 4.93914 10.8191 4.59916 10.6104 4.38965Z" fill="currentColor" />
    </svg>
  );
}
